import { Trans } from '@lingui/macro';
import * as React from 'react';

export const TriggerButtonContent = (props: React.PropsWithChildren<{
  done: boolean,
  hasError: boolean,
}>) => {
  const {
    done,
    hasError,
    children,
  } = props;
  if (hasError) {
    return (
      <Trans>
        Erreur
      </Trans>
    );
  }
  if (done) {
    return (
      <Trans>
        Demande envoyée
      </Trans>
    );
  }
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {children}
    </>
  );
};
